import i18n from 'i18n';

export const getCaptionsLanguageLabel = (value: string) => {
  const [lang, region = null] = value.split('-');
  if (region) {
    return `${i18n.t(`settings:captions.languages.${lang}`)} (${i18n.t(`settings:captions.languages.${value}`)})`;
  }

  return i18n.t(`settings:captions.languages.${lang}`);
};
